import React from 'react';
import UnionTableList from 'Components/union/unionTableList';
import CommonTable from 'Components/common/commonTable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actions from 'Actions/taskManage/interactivePath';
import { Tooltip, Icon } from "antd"
class TableList extends UnionTableList {
    showDetail = (record) => {
        let { detailListParams } = this.props;
        this.props.actions.setState({
            key: "detailListParams",
            value: {
                statisticId: record.id,
                pageNum: 1,
                pageSize: 10,
            }
        })
        this.props.setTableListLoading();
        //请求饼图数据   //请求列表数据
        Promise.all([
            this.props.actions.getDetailCount({ statisticId: record.id }),
            this.props.actions.getDetailList({ ...detailListParams, statisticId: record.id })
        ]).then(res => {
            //显示抽屉，设置true
            this.props.actions.setState({ key: "showDetail", value: true })
        }).finally(_ => {
            this.props.setTableListLoading();
        })


    }
    render() {
        const {
            tableListData: { data = [], total = 0 },
            pageStatus,
            loading,
            pageStatus: { pageNum, pageSize },
        } = this.props;
        const columns = () => {
            return [
                {
                    title: '序号',
                    width: 80,
                    render: (text, record, index) => {
                        return index + 1;
                    }
                },
                {
                    title: '时间',
                    dataIndex: 'dayStr',
                    key: 'dayStr',
                },
                {
                    title: '任务名称',
                    dataIndex: 'taskName',
                    width: 150,
                    ellipsis: true,
                    key: 'taskName',
                },
                {
                    title: '匹配类型',
                    dataIndex: 'matchType',
                    key: 'matchType',
                },
                {
                    title: '节点名/faq标准问',
                    width: 200,
                    ellipsis: true,
                    dataIndex: 'matchContent',
                    key: 'matchContent',
                },
                {
                    title: () => (
                        <span>
                            接通量
                            <Tooltip title={<span>单位时间内当前外呼任务已外呼接通的电话量</span>}>
                                <Icon type="info-circle" style={{ marginLeft: '6px', color: '#1a2026' }} />
                            </Tooltip>
                        </span>
                    ),
                    dataIndex: 'answeredNum',
                    key: 'answeredNum',
                },
                {
                    title: () => (
                        <span>
                            响应量
                            <Tooltip title={<span>单位时间内当前外呼任务中触发的机器人匹配类型的次数。<br />
                                例如：在【外呼任务A】中触发了【语音留言】这条faq20次
                            </span>}>
                                <Icon type="info-circle" style={{ marginLeft: '6px', color: '#1a2026' }} />
                            </Tooltip>
                        </span>
                    ),
                    dataIndex: 'replyNum',
                    key: 'replyNum',
                    render: (text, record, index) => {
                        return <span style={{ color: '#40aefc', cursor: 'pointer' }} onClick={() => this.showDetail(record)}>{text}</span>
                    }
                },
                {
                    title: () => (
                        <span>
                            挂机量
                            <Tooltip title={<span>单位时间内当前外呼任务在节点或faq触发挂机指令的次数</span>}>
                                <Icon type="info-circle" style={{ marginLeft: '6px', color: '#1a2026' }} />
                            </Tooltip>
                        </span>
                    ),
                    dataIndex: 'hangupNum',
                    key: 'hangupNum',
                },
            ]
        }
        return (
            <React.Fragment>
                <CommonTable
                    key={this.customize || ""}
                    columns={columns(pageStatus, this.handleAction)}
                    dataSource={[...data]}
                    rowKey="id"
                    extraHeight={48}
                    loading={loading}
                    // scroll={{ x: this.customize === 'txgg' ? 2760 : 1800 }}
                    onChange={this.handleTableChange}
                    pagination={{
                        current: pageNum,
                        total: total && parseInt(total, 10),
                        pageSize,
                        showTotal: () => `共 ${total} 条`,
                    }}
                />
            </React.Fragment >
        )
    }
}
const mapStateToProps = (state) => ({
    ...state.taskManageInteractivePath,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(TableList);